const loadingConstants = {
  ADD_LOADING_IN_PROGRESS: "ADD_LOADING_IN_PROGRESS",
  REMOVE_LOADING_IN_PROGRESS: "REMOVE_LOADING_IN_PROGRESS",
}

export default loadingConstants;
